import { createContext, useContext, useMemo } from "react";

// Lets components in this package show translated text without depending on the host app's
// label store. The host mounts <LabelsProvider getLabel={...}> once, high in the tree; components
// call `const [getLabel] = useUiLabels();` (same first element as the webapp's useLabels()).
//
// Without a provider the key itself is returned, which is also what the tests of the host app
// mock (`() => [(key) => key]`).
const identityGetLabel = (key) => key;
const DEFAULT_VALUE = [identityGetLabel];

const LabelsContext = createContext(DEFAULT_VALUE);

export const LabelsProvider = ({ getLabel, children }) => {
  // The tuple is memoised on getLabel so consumers only re-render when the function changes.
  const value = useMemo(
    () => (getLabel ? [getLabel] : DEFAULT_VALUE),
    [getLabel]
  );
  return (
    <LabelsContext.Provider value={value}>{children}</LabelsContext.Provider>
  );
};

export const useUiLabels = () => useContext(LabelsContext);
